var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { IconButton as FluentIconButton, concatStyleSets, useTheme, } from "@fluentui/react";
import React, { useEffect, useRef, useState, } from "react";
import { getBaseButtonStyle } from "../Button/Button.styles";
import { TooltipHost } from "../TooltipHost/TooltipHost";
import { getBaseIconButtonStyle } from "./IconButton.styles";
export const IconButton = (_a) => {
    var { icon, iconStyles, menu, styles, isDisabled, onAfterMenuDismiss, tooltipText, tooltipDirectionalHint, tooltipDirectionalHintForRTL } = _a, rest = __rest(_a, ["icon", "iconStyles", "menu", "styles", "isDisabled", "onAfterMenuDismiss", "tooltipText", "tooltipDirectionalHint", "tooltipDirectionalHintForRTL"]);
    const theme = useTheme();
    const buttonIconElement = useRef(null);
    const [tooltipTarget, setTooltipTarget] = useState();
    useEffect(() => {
        if (buttonIconElement.current) {
            setTooltipTarget(buttonIconElement.current);
        }
    }, [buttonIconElement]);
    return (React.createElement(TooltipHost, { content: tooltipText, directionalHint: tooltipDirectionalHint, directionalHintForRTL: tooltipDirectionalHintForRTL, target: tooltipTarget },
        React.createElement(FluentIconButton, Object.assign({}, rest, { elementRef: buttonIconElement, iconProps: { iconName: icon, styles: iconStyles }, menuProps: menu, disabled: isDisabled, onAfterMenuDismiss: onAfterMenuDismiss, onRenderMenuIcon: () => {
                return null;
            }, styles: concatStyleSets(getBaseButtonStyle(theme), getBaseIconButtonStyle(theme), styles) }))));
};
